module.exports = __webpack_public_path__ + "8a236e154c0fc4fbab8a037ec6f2d927.mp4";